import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { IntercityStop } from '@ridango/core';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { StopsActions } from './+state/stops.actions';

@Injectable({
    providedIn: 'root'
})
export class StopsService {
    private stops: IntercityStop[];
    constructor(
        @Inject('ENV') private env: any,
        private http: HttpClient,
        private ngRedux: NgRedux<any>,
        private actions: StopsActions
    ) {}

    // is for intercity purchase, grouped by stop area basically
    getStopsRequest(): Observable<any> {
        return this.http.get(`${this.env.API_BASE_URL}/${this.env.REGION_ID}/intercity/originstops`).pipe(
            map((s: any) => {
                s.map((stop) => {
                    stop.id = stop.stop_area_id;
                    stop.name = stop.stop_name;
                    stop.type = stop.stop_type ? stop.stop_type : null;
                    stop.label = stop.stop_name;
                    return stop;
                });
                return s;
            })
        );
    }
    // returns ungrouped stops with coordinates (for map usage basically)
    getAllStopsRequest(): Observable<any> {
        return this.http.get(`${this.env.API_BASE_URL}/${this.env.REGION_ID}/transit/stops`);
    }

    /**@deprecated use stopsFacade.getAllZones() to make request and stops will be set in epic */
    getAllZones() {
        return this.http.get(`${this.env.API_BASE_URL}/${this.env.REGION_ID}/intercity/allzones`).pipe(
            map((s: any) => {
                s.map((stop) => {
                    stop.display = stop.name;
                    return stop;
                });
                return s;
            })
        );
    }

    getAllZonesRequest() {
        return this.http.get(
            `${this.env.CORE_API_URL}/customer/v3/region/${this.env.REGION_ID}/transit/zones/channel/${this.env.CHANNEL}`
        );
    }

    getStopsWithZonesRequest() {
        return this.http.get(`${this.env.API_BASE_URL}/${this.env.REGION_ID}/transit/stops_with_zones`);
    }

    /**@deprecated use stopsFacade.getStops() to make request and stops will be set in epic */
    setAllStops(payload) {
        this.ngRedux.dispatch(this.actions.fetchSuccess(payload));
    }

    /**@deprecated use method from stops.facade */
    setSelectedOrigin(stop: IntercityStop) {
        this.ngRedux.dispatch(this.actions.setSelectedOrigin(stop));
    }

    /**@deprecated use method from stops.facade */
    setSelectedDestination(stop: IntercityStop) {
        this.ngRedux.dispatch(this.actions.setSelectedDestination(stop));
    }

    /**@deprecated use method from stops.facade */
    setAllAreasSelected(isSet: boolean) {
        this.ngRedux.dispatch(this.actions.setAllAreasSelected(isSet));
    }

    /**@deprecated use stopFacade.all$ observable */
    getAllAreasStatus(rootStore: string): Observable<any> {
        return this.ngRedux.select([rootStore, 'allAreas']);
    }
}
